<template>
  <section class="home">
    <div class="container">
      <div class="row">
        <div class="col-lg-7 col-md-8">
          <a href="https://skylineconference.co" class="logo">
            <img src="../assets/SkylineAugustLogos_Black.svg" alt="Skyline" />
            <img src="../assets/SkylineAugustLogos_Black_Hover.svg" alt="Skyline" class="hover" />
          </a>
          <h1>Exploring the intersection of real estate and technology</h1>
          <p>Sign up for Skyline's weekly newsletter. Stay informed on the latest in proptech, contech, and urbantech, for free.</p>
          <div class="email-form">
            <form class="form form-inline" v-on:submit="subscribe">
              <div class="form-group email-group">
                <input type="email" name="email" id="email" class="form-control" placeholder="Enter email address" v-model="email" />
              </div>
              <div class="form-group">
                <button type="submit" class="btn btn-primary">
                  <span v-if="!isLoadingSubscribe">Submit</span>
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-else></span>
                </button>
              </div>
            </form>
          </div>
          <p v-if="error" class="feedback error">{{ error }}</p>
          <p v-if="success" class="feedback success">{{ success }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios"

export default {
  name: 'Home',
  data: function () {
    return {
      email: "",
      error: "",
      success: "",
      isLoadingSubscribe: false,
    }
  },
  mounted: function() {
    if (this.$route.params.referralCode) {
      window.localStorage.setItem('referral', this.$route.params.referralCode)
    }
  },
  methods: {
    subscribe: function(e) {
      e.preventDefault()
      this.error = ""

      if (!this.email || !/@/.test(this.email)) {
        this.error = "Please enter an email address"
      }
      else {
        this.isLoadingSubscribe = true

        axios.post('/api/subscribe', {
          email: this.email,
          referral: window.localStorage.getItem('referral') || "",
        })
          .then(() => {
            this.isLoadingSubscribe = false
            this.email = ""
            this.success = "Thanks! Please check your email to confirm your subscription."
          })
          .catch((error) => {
            this.isLoadingSubscribe = false
            if (error.response) {
              this.error = error.response.data.error
            }
            else {
              this.error = "Sorry, something went wrong. Please try again later."
            }
          })
      }
    },
  },  
  components: {    
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/variables";

section.home {
  height: 100vh;
  min-height: 500px;
  background-image: url('../assets/skyline-phone.png'), linear-gradient(146deg, #FFFFFF 28%, #E4E4E4 100%);
  background-position: right center, center center;
  background-size: 45% auto, cover;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;

  @media all and (max-width: $tabletMax) {
    background-size: 40% auto, cover;
  }

  @media all and (max-width: $mobileMax) {
    height: auto;
    min-height: 100vh;
    align-items: flex-start;
    padding-top: 150px;
    background-position: right top 120px, center center;
    background-size: 40% auto, cover;
  }
}

a.logo {
  display: block;

  img {
    width: 196px;
    height: auto;

    &.hover {
      position: absolute;
      top: 0;
      left: 15px;
      opacity: 0;
    }
  }

  &:hover {
    img {
      &:not(.hover) {
        opacity: 0;
      }
      &.hover {
        opacity: 1;
      }
    }
  }
}

h1 {
  font-weight: 700;
  font-size: 45px;
  line-height: 1.2222;
  margin: 31px 0 12px;

  @media all and (max-width: $tabletMax) {
    font-size: 30px;
  }
}

p {
  font-size: 16px;
  line-height: 1.625;
  color: #263035;
  max-width: 75%;

  @media all and (max-width: $tabletMax) {
    max-width: 100%;
  }
}

div.email-form {
  background: #FFFFFF;
  box-shadow: 0 10px 30px 0 rgba(0,0,0,0.10);
  padding: 22px 22px 22px 45px;
  background-image: url('../assets/dots-grey.svg');
  background-position: left 23px center;
  background-repeat: no-repeat;
  margin: 38px 0 0;

  @media all and (max-width: $mobileMax) {
    background-position: left 20px top 20px;
  }
}

form.form.form-inline {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

div.email-group {
  flex-grow: 1;
  margin-right: 17px;

  @media all and (max-width: $mobileMax) {
    margin-right: 0;
  }
}

div.form-group {
  @media all and (max-width: $mobileMax) {
    width: 100%;
  }
}

input.form-control {
  border: 1px solid #D8D8D8;
  border-radius: 0;
  font-size: 14px;
  width: 100%;
}

button.btn.btn-primary {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.24px;
  text-transform: uppercase;
  padding-left: 2rem;
  padding-right: 2rem;

  @media all and (max-width: $mobileMax) {
    width: 100%;
    display: block;
  }
}

p.feedback {
  font-size: 14px;
  font-weight: 700;
  margin: 20px 0 0;
}
</style>
